import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import Cookies from "js-cookie";

import * as AuthServices from '../../services/auth.service';
import { ATLEAST_ONE_CAPITAL_REGEX, ATLEAST_ONE_NUMBER_REGEX, ATLEAST_ONE_SMALL_REGEX, ATLEAST_ONE_SPECIAL_CHARACTER_REGEX, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, SWAL_SETTINGS } from "../../../../utils/Constants";
import { PHONE_VALIDATION } from "../../../../utils/CommonValidatiobn";
import Swal from "sweetalert2";
import { handleServerValidations, removeSessionKey, setLocalKey, setSessionKey } from "../../../../utils/commonfunction";
import { useDispatch } from "react-redux";
import { addProfileData } from "../../../../redux/slices/profileslice";
import { useNavigate, useSearchParams } from "react-router-dom";
import PhoneInput from "../../../../utils/PhoneInput";

function ForgotPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [submitted, setSubmitted] = useState(false);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .trim()
      .email(t("vaildation.email_invalid"))
      .matches(
        /^[a-zA-Z0-9._%+-]+@[A-Za-z0-9-]+\.[A-Za-z]{2,63}$/,
        t("vaildation.valid_email_address")
      )
      .required(t("vaildation.email_required")),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: ''
    },
    validationSchema: validationSchema,
    validateOnBlur: false,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      setSubmitted(true);
      let formData = new FormData();
      formData.append("email", values.email);

      setSubmitted(false);
      AuthServices
        .forgetPassword(formData)
        .then((response) => {
          setSubmitted(true);

          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            navigate('../success');
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setSubmitted(true);
          console.log("error ====> ", error);
        });
    },
  });

  return (
    <section className="py-8 md:py-12 lg:py-16 form-bg">
      <div className="container">
        <div className="mb-8">
          <h1 className="headings-h1 text-center text-zinc-950 mb-2">
            {t('advertiser.auth.forgot_password_title')}
          </h1>
          <p className="text-center text-zinc-500 body-lg">
            {t('advertiser.auth.forgot_password_desc')}
          </p>
        </div>
        <div className="bg-white p-[15px] md:p-[50px] rounded-[10px] max-w-[475px] shadow-[0px_2px_24px_rgba(0,0,0,0.05)] w-full mx-auto border border-zinc-100 w-full">
          <form onSubmit={formik.handleSubmit} className="space-y-5">
            <div className="form-group">
              <label htmlFor="email" className="">{t('advertiser.auth.email_address')} <span className="text-danger">*</span></label>
              <input
                id="email"
                type="email"
                placeholder={t('advertiser.auth.email_address')}
                className="form-control-custom"
                // required
                name="email"
                value={formik.values.email}
                onChange={(e) => {
                  const val = e.target.value.toLowerCase().replace(/\s/g, "");
                  formik.setFieldValue("email", val);
                }}
                onBlur={formik.handleBlur}
              />
              <span className="text-danger text-left d-blockerr-spn">
                {formik.errors.email && formik.touched.email && formik.errors.email}
              </span>
            </div>
            <button type="submit" className="btn btn-pri w-full mt-4">
              {t('advertiser.auth.send_reset_link')}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ForgotPassword;
